package com.findyourbuddies.website.components

import androidx.compose.runtime.Composable
import com.findyourbuddies.website.utils.ResourcesUtils
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.functions.min
import com.varabyte.kobweb.compose.css.objectFit
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Img

@OptIn(ExperimentalComposeWebApi::class)
@Composable
fun CarouselItem(
    imageUrl: String,
    description: String,
    modifier: Modifier = Modifier,
    isLandscape: Boolean = false,
) {
    if (isLandscape) {
        Box(
            modifier = modifier
                .position(Position.Relative)
                .padding(100.px, 60.px)
                .fillMaxWidth(),
            contentAlignment = Alignment.Center
        ) {
            CarouselItemLandscape(
                imageUrl = imageUrl,
                description = description
            )
        }
    } else {
        NewCarouselItemPortrait(
            imageUrl = imageUrl,
            description = description,
        )
    }
}

@OptIn(ExperimentalComposeWebApi::class)
@Composable
private fun CarouselItemLandscape(
    imageUrl: String,
    description: String,
    modifier: Modifier = Modifier,
) {
    Box(
        modifier = modifier,
        contentAlignment = Alignment.Center
    ) {
        Box(
            modifier = Modifier
                .width(min(800.px, 80.vw))
                .maxWidth(800.px)
                .height(300.px)
                .styleModifier {
                    background("linear-gradient(135deg, rgb(157, 179, 218) 0%, rgb(98, 131, 178) 100%)")
                }
                .borderRadius(16.px)
                .padding(40.px, 20.px, 40.px, 20.px)
                .position(Position.Relative)
        ) {
            Column(
                horizontalAlignment = Alignment.Start,
                verticalArrangement = Arrangement.Center,
                modifier = Modifier
                    .fillMaxSize()
                    .padding(left = 360.px, right = 100.px)
            ) {
                SpanText(
                    description,
                    modifier = Modifier
                        .fontSize(16.px)
                        .color(Colors.White)
                        .lineHeight(1.5)
                        .textAlign(TextAlign.Justify)
                        .fontFamily("Comfortaa", "Arial", "sans-serif")
                )
            }

            Box(
                modifier = Modifier
                    .position(Position.Absolute)
                    .top(50.percent)
                    .left((-40).px)
                    .width(400.px)
                    .height(500.px)
                    .styleModifier {
                        transform { translateY((-50).percent) }
                    }
                    .borderRadius(12.px)
                    .padding(8.px)
            ) {
                Img(
                    src = ResourcesUtils.getResourcePath(imageUrl),
                    alt = "Mockup application",
                    attrs = {
                        style {
                            width(100.percent)
                            height(100.percent)
                            objectFit(ObjectFit.Contain)
                            borderRadius(8.px)
                        }
                    }
                )
            }
        }
    }
}

@Composable
private fun NewCarouselItemPortrait(
    imageUrl: String,
    description: String,
) {
    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.Center,
    ) {
        Box(
            modifier = Modifier
                .width(200.px)
                .height(350.px)
                .position(Position.Absolute)
                .top(0.px)
                .zIndex(10),
        ) {
            Img(
                src = imageUrl,
                alt = "Mockup application",
                attrs = {
                    style {
                        width(100.percent)
                        height(100.percent)
                        objectFit(ObjectFit.Contain)
                    }
                },
            )
        }

        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(200.px)
                .position(Position.Absolute)
                .bottom(0.px)
                .borderRadius(16.px)
                .styleModifier {
                    background("linear-gradient(135deg, rgb(157, 179, 218) 0%, rgb(98, 131, 178) 100%)")
                }
                .zIndex(5),
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(100.px)
                    .position(Position.Absolute)
                    .bottom(0.px)
                    .padding(left = 20.px, right = 20.px),
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.Center,
            ) {
                SpanText(
                    description,
                    modifier = Modifier
                        .fontSize(13.px)
                        .color(Colors.White)
                        .lineHeight(1.3)
                        .textAlign(TextAlign.Center)
                        .fontFamily("Comfortaa", "Arial", "sans-serif")
                )
            }
        }
    }
}
